export default __webpack_public_path__ + "static/media/invoice.f5830cf9.png";